import { getCartQuery } from 'components/layout/cart';
import { getFooterQuery } from 'components/layout/footer';
import { getNewsletterPopupQuery } from 'components/layout/newsletterPopup';
import { getUspBanner } from 'components/layout/uspBanner';
import { getStoreLocaleSelectorQuery } from 'components/layout/StoreLocaleSelector';
import { fetchContent } from 'lib/contentful/api';
import fetchHeader from './fetchHeader';
import fetchGlobalModule from './fetchGlobalModule';

const getLayoutItems = async (locale, preview, store = 'eu') => {
  const [header, uspBanner, newsletter, footer, cart, newsletterPopup, storeLocaleSelector] =
    await Promise.all([
      fetchHeader({ locale, preview }),
      getUspBanner({ locale, preview, store }),
      fetchGlobalModule('Newsletter', locale, preview),
      ...[
        getFooterQuery({ locale, preview }),
        getCartQuery({ locale, preview }),
        getNewsletterPopupQuery({ locale, preview }),
        getStoreLocaleSelectorQuery({ locale, preview }),
      ].map(query => fetchContent(query, preview)),
    ]);

  return {
    header,
    uspBanner,
    footer: footer
      ? {
          ...footer,
          resources: newsletter?.resourcesCollection?.items || [],
        }
      : undefined,
    cart,
    newsletterPopup,
    storeLocaleSelector,
  };
};

export default getLayoutItems;
